import { autoserialize, autoserializeAs } from 'cerialize';
import { OperationsAlertInfo } from './operations-alert-info';

export class OperationsAlertList {
  @autoserialize
  assignedCount: number;

  @autoserialize
  nonassignedCount: number;

  @autoserialize
  totalCount: number;

  @autoserializeAs(OperationsAlertInfo)
  operationsAlertInfos: Array<OperationsAlertInfo>;
}
